import { render, staticRenderFns } from "./yjreplenishment.vue?vue&type=template&id=5c65b8b1&scoped=true&"
import script from "./yjreplenishment.vue?vue&type=script&lang=js&"
export * from "./yjreplenishment.vue?vue&type=script&lang=js&"
import style0 from "./yjreplenishment.vue?vue&type=style&index=0&id=5c65b8b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c65b8b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c65b8b1')) {
      api.createRecord('5c65b8b1', component.options)
    } else {
      api.reload('5c65b8b1', component.options)
    }
    module.hot.accept("./yjreplenishment.vue?vue&type=template&id=5c65b8b1&scoped=true&", function () {
      api.rerender('5c65b8b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/replenishment/yjreplenishment.vue"
export default component.exports